<template>
  <router-link v-if="isExtenalPath" :class="extraClass" :to="linkStr">
    <slot></slot>
  </router-link>
  <a v-else :class="`${extraClass}`" :href="linkStr">
    <slot></slot>
  </a>
</template>
<script>
export default {
  name: 'PZLink',

  props: {
    isExtenalPath: Boolean,
    extraClass: String,
    linkStr: String,
  },
};
</script>
